<template>
  <div class="reporting-container">
    <div class="reportingbox" title="举报须知">
      <h3 style="text-indent: 2em;">
        感谢您对科技计划项目管理和科研诚信建设的关注与支持。为维护良好科研生态，郑重倡导负责任地行使监督权利，请在提交举报前务必仔细阅读以下举报须知。</h3>
      <h3>一 、受理范围</h3>
      <p>
        （一）科技计划项目违规行为。山东省科学技术厅负责管理的各类科技计划项目的申请、评审、实施、结题和成果发表与应用等科技活动中发生的违规行为，包括但不限于抄袭剽窃、侵占他人研究成果或项目申请书；买卖、代写、代投论文或项目申报验收材料等，虚构同行评议专家及评议意见；以故意提供虚假信息等弄虚作假的方式或采取“打招呼”“走关系”、贿赂、利益交换等不正当手段获得科研活动审批，获取科技计划（专项、基金等）项目、科研经费、奖励、荣誉、职务职称等（详见附件1）。</p>
      <p>
        （二）科研活动科研失信行为。山东省行政区划范围内的科研单位、科研人员、咨询评审专家、第三方科学技术服务机构及其工作人员、受托管理机构及其工作人员等责任主体，在参与山东省科学技术厅负责管理的各类科技计划项目以外的相关科学技术活动中发生的科研失信行为，包括但不限于管理失职，造成负面影响或财政资金损失；无实质学术贡献署名，违反论文、奖励、专利等署名规范，违反学术出版规范等（详见附件2）。</p>
      <h3>二、受理条件</h3>
      <p>（一）有明确的举报对象；</p>
      <p>（二）举报内容属于上述受理范围；</p>
      <p>（三）有明确的违规事实；</p>
      <p>（四）有客观、明确的证据材料或可查证线索；</p>
      <p>（五）通过电话、系统进行举报。</p>
      <h3>三、不予受理情形</h3>
      <p>
        （一）山东省科学技术厅负责管理的各类科技计划项目以外的项目违规行为举报或对于不属于山东省行政区划范围的人员、单位的科研活动科研失信举报；</p>
      <p>（二）没有明确的证据和可查证线索的；</p>
      <p>（三）对同一对象重复举报且无新的证据、线索的；</p>
      <p>（四）已经作出生效处理决定且无新的证据、线索的；</p>
      <p>（五）虚假、恶意举报的；</p>
      <p>（六）其他不予受理的情形。</p>
      <h3>四、注意事项</h3>
      <p style="text-indent: 2em; font-weight: bold;">
        提倡实名举报（请提供有效身份信息和准确联系方式），举报人对举报事实的真实性负责，不得捏造、歪曲事实，不得诬告、陷害他人。应提供完整事实依据和有效证明材料；对于故意捏造事实、实施诬告陷害行为的，将依法依规追究其相应法律责任与纪律责任。</p>
      <p style="color:red; font-weight: bold; font-size: 1.3rem;">重要提醒：请注意涉及国家秘密的举报，请勿通过本网站提交。</p>
      <div class="agreement-section">
      <el-checkbox v-model="checked">我已阅读并同意以上条款</el-checkbox>
        <div class="attachment-links">
          <a href="./static/pdf/attachment1.pdf" target="_blank" class="attachment-link">附件1：山东省科学技术厅科技计划项目违规主体解释及行为清单.pdf</a>
          <a href="./static/pdf/attachment2.pdf" target="_blank" class="attachment-link">附件2：违反科研失信行为主体解释及清单.pdf</a>
        </div>
      </div>
      <!-- <el-divider></el-divider> -->
      <br>
      <div class="jc-c">
        <div type="primary" @click="realname" class="real-name"
             :class="{ disabled: countdownActive }">
          <img src="../../../assets/img/themes/real-name.png" alt="">
          {{ countdownActive ? `实名举报 (${countdown}s)` : '实名举报' }}
        </div>
        <div type="warning" @click="anonymous " class="anonymous"
             :class="{ disabled: countdownActive }">
          <img src="../../../assets/img/themes/anonymous.png" alt="">
          {{ countdownActive ? `匿名举报 (${countdown}s)` : '匿名举报' }}
        </div>
      </div>
    </div>
    <div>
      <div class="right-div result" @click="routepush" style="cursor:pointer;">
        查看反馈结果
        <img src="../../../assets/img/themes/arrow.png" alt="">
      </div>
      <div class="right-div phone">
        监督服务电话：<br>
        0531-51751097<br>
        （工作日 9:00-11:30 14:00-17:00）
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      checked: false,
      countdown: 10, // 倒计时秒数
      countdownActive: true // 倒计时是否激活
    }
  },
  methods: {
    routepush () {
      this.$router.push("/research-integrity/tabulation")
    },
    realname () {
      if (this.countdownActive) return;
      if (!this.checked) {
        this.$message({
          message: '请先阅读以上条款',
          type: 'warning'
        });
      } else {
        this.$router.push(
            {
              path: "/research-integrity/realname",
              query: {
                id: 1
              }
            }
        )
      }
    },
    anonymous () {
      if (this.countdownActive) return;
      if (!this.checked) {
        this.$message({
          message: '请先阅读以上条款',
          type: 'warning'
        });
      } else {
        this.$router.push(
            {
              path: "/research-integrity/anonymous",
              query: {
                id: 1
              }
            }
        )
      }
    },
    startCountdown () {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown--;
          this.startCountdown();
        }, 1000);
      } else {
        this.countdownActive = false;
        // 倒计时结束记录cookie，有效期间内刷新页面不需要重新倒计时
        this.setTimedCookie('countdownFlag', true, 10)
      }
    },
    // 设置带过期时间的 Cookie
    setTimedCookie (name, value, minutes) {
      const date = new Date();
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    },
    // 获取 Cookie
    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  },
  mounted () {
    const flag = this.getCookie('countdownFlag')
    if (flag) {
      this.countdown = 0
      this.countdownActive = false
    }
    this.startCountdown();
  }
}
</script>

<style lang="scss" scoped>
.reporting-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  width: 1280px;
  margin: 0 auto;
  padding: 20px 0;
}

.reportingbox {
  flex: 1;
  max-width: 1000px;
  margin: 20px 0 auto;
  overflow: auto;
  background: #FFFFFF;
  box-sizing: border-box;
  padding: 0 20px;
  border-top: 3px solid #1E8CE6;
}

.right-div {
  width: 180px;
  height: 180px;
  text-align: center;
  flex-shrink: 0;
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-top: 20px;

  img {
    width: 30px;
    margin-top: 10px;
  }
}

.result {
  //background-color: aqua;
  background-image: url('../../../assets/img/themes/feedbackimg.png');
}

.phone {
  background-color: #4badeb;
}

p {
  margin: 0;
  line-height: 28px;
  font-size: 1.1em;
}

.anonymous {
  width: 200px;
  height: 50px;
  background: #FF850C;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  cursor: pointer;
}

.real-name {
  width: 200px;
  height: 50px;
  background: #157ED6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  margin-right: 20px;
  cursor: pointer;
}
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agreement-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-top: 10px;
}

.attachment-links {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.attachment-link {
  color: #1E8CE6;
  text-decoration: underline;
  font-size: 1em;

  &:hover {
    color: #157ED6;
  }
}
</style>
